import { useState, useRef, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { usePermissions } from "src/hooks/usePermissions";
import FormContext from "src/context/FormContext";
import { getClaimDisplayAddressString } from "src/components/Form/Claim/helper";

export function useClaimEffects() {
  const [submitClicked, setSubmitClicked] = useState(false);
  const {
    displayingSnackbar,
    setDisplayingSnackbar,
    setFormState,
    displayingAlertBanner,
    setDisplayingAlertBanner,
  } = useContext(FormContext);

  const premiseBlockRef = useRef(null);
  const accountBlockRef = useRef(null);
  const electricityBlockRef = useRef(null);
  const gasLineBlockRef = useRef(null);
  const gasBothBlockRef = useRef(null);
  const gasMeterBlockRef = useRef(null);
  const closeTransferBlockRef = useRef(null);

  const location = useLocation();
  const { isHomeUser } = usePermissions();

  const propertyDetails =
    location?.state?.claimTarget?.claimableJourney?.property_details;
  const siteDetails = propertyDetails?.site_details;

  const computedAddressFromDbForm = propertyDetails
    ? getClaimDisplayAddressString(propertyDetails, siteDetails)
    : null;

  const computedAddressState = siteDetails?.state ?? null;

  useEffect(() => {
    if (computedAddressFromDbForm) {
      setFormState((prevState) => ({
        ...prevState,
        address: computedAddressFromDbForm,
      }));
    }
    if (computedAddressState) {
      setFormState((prevState) => ({
        ...prevState,
        state: computedAddressState,
      }));
    }
  }, [computedAddressFromDbForm, computedAddressState, setFormState]);

  const isClaim =
    typeof location !== "undefined" && location.hash.includes("claim");
  const dialogValues = location.state;
  return {
    submitClicked,
    setSubmitClicked,
    displayingSnackbar,
    setDisplayingSnackbar,
    setFormState,
    displayingAlertBanner,
    setDisplayingAlertBanner,
    premiseBlockRef,
    accountBlockRef,
    electricityBlockRef,
    gasLineBlockRef,
    gasBothBlockRef,
    gasMeterBlockRef,
    closeTransferBlockRef,
    isClaim,
    isHomeUser,
    computedAddressFromDbForm,
    computedAddressState,
    dialogValues,
  };
}
